import React, { useEffect, useMemo } from 'react';
import { useCollect } from 'hooks';

import DayJs from 'utils/Dayjs';

import Show from 'components/Show';
import Icon from 'components/Misc/Icon';
import Progress from 'components/Misc/Progress';
import { Title } from 'components/Misc/Typography';

import Webinar from 'containers/Student/Home/Webinars/Webinar';

const Webinars = () => {
	// Store request parameters
	const parameters = useMemo(() => ({
		eager: '[subject, course]',
		'eventAt:gt': DayJs().subtract(2, 'hour').toISOString(),
		type: 'online',
		rangeStart: 0,
		rangeEnd: 4
	}), []);

	// Store requested webinars
	const [[webinars, progress], collect] = useCollect('webinars', parameters);

	// Collect webinars on mount and on parameter change
	useEffect(() => {
		(async () => await collect())();
	}, [collect]);

	return (
		<div className="space-y-4">
			<div className="flex items-center space-x-2">
				<Icon
					icon="voice_chat"
					className="text-amber-500 text-xl"
				/>

				<Title
					title="Tuvākie vebināri"
					className="text-xl flex-1"
				/>
			</div>

			{/* Show progress */}
			<Progress progress={progress} />

			{/* Show nothing if there are no webinars */}
			<Show if={!progress && !webinars?.total}>
				<div className="py-4 flex flex-col items-center space-y-2">
					<Icon
						icon="celebration"
						className="text-4xl text-neutral-400 dark:text-neutral-600"
					/>
				
					<div className="font-base text-neutral-400 dark:text-neutral-600">
						Pašlaik Tev nav plānotu vebināru!
					</div>
				</div>
			</Show>

			{/* Show collected webinars */}
			<Show if={webinars?.total && !progress}>
				<div className="space-y-2">
					{webinars?.results?.map(webinar =>
						<Webinar key={webinar.id} webinar={webinar} />
					)}
				</div>
			</Show>
		</div>
	);
};

export default Webinars;